import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RamTargetsComponent } from "./ram-targets.component";
import { SharedModule } from "../shared.module";
import { SharedImportsModule } from "../shared/shared-imports.module";
import { FormsModule } from '@angular/forms';

const componentList = [RamTargetsComponent];

@NgModule({
  declarations: [componentList],
  imports: [CommonModule, SharedImportsModule, FormsModule, SharedModule]
})
export class RamTargetsModule {}
